module.exports = __webpack_public_path__ + "static/media/prize.614fb3c0.png";